import { setRenderingEnv } from 'app/RenderingEnvironment/actions';
import { renderingEnvNameSelector } from 'app/RenderingEnvironment/selectors';
import { editableComponentsListSelector } from 'app/Can/selectors';
import connect from 'utils/store/connect';

import CreateNewMasterComponent from './components/CreateNewMasterComponent';
import { createNewMasterComponentThunk as createNewComponent } from './thunks';

/**
 * maps redux state to component props
 * @param {object} state - the current state
 * @returns {object} properties of state to be mapped to this component's props
 */
const mapStateToProps = state => ({
  componentsList: editableComponentsListSelector(state),
  renderingEnvName: renderingEnvNameSelector(state)
});

/**
 * Returns object mapping dispatches to props
 * @returns {object}
 */
const mapDispatchToProps = {
  createNewComponent,
  setRenderingEnv
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewMasterComponent);
